/**
 * @generated SignedSource<<7d7b22ff370d9e9a7a741a37c508a145>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraWorkManagementUserLicenseSeatEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectHeader_inner_query$data = {
  readonly jira: {
    readonly jwmLicensing: {
      readonly currentUserSeatEdition: JiraWorkManagementUserLicenseSeatEdition | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "ProjectHeader_inner_query";
};
export type ProjectHeader_inner_query$key = {
  readonly " $data"?: ProjectHeader_inner_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_inner_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectHeader_inner_query",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};

(node as any).hash = "6b10db5d77a3ec3bb1e3665b0de46b2f";

export default node;
